import {
  CartItemTypes,
  ICartItemType,
} from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import CartItemProduct from "./cart-item/CartItemProduct";
import CartItemSlot from "./cart-item/CartItemSlot";
import CartHeader from "./CartHeader";
import CartItemConsultation from "./cart-item/CartItemConsultation";
import CartItemEvent from "./cart-item/CartItemEvent";

interface Props {
  cartItems: ICartItemType[];
  mobile?: boolean;
  menu?: boolean;
}

const AllCartItems: React.FC<Props> = ({
  cartItems,
  mobile = false,
  menu = false,
}) => {
  const mClass = mobile || menu ? "-mobile" : "";
  return (
    <div className={`cart${mClass}`}>
      {!menu && <CartHeader itemsCount={cartItems?.length} />}
      {cartItems?.map((item) =>
        item.type === CartItemTypes.product ? (
          <CartItemProduct
            key={item.id}
            cartItem={item}
            mobile={mobile}
            menu={menu}
          />
        ) : item.type === CartItemTypes.slot ? (
          <CartItemSlot key={item.id} cartItem={item} />
        ) : item.type === CartItemTypes.event ? (
          <CartItemEvent key={item.id} cartItem={item} />
        ) : (
          <CartItemConsultation key={item.id} cartItem={item} />
        ),
      )}
    </div>
  );
};

export default AllCartItems;
